import { FC, useContext } from 'react'

import { ScreenContext } from 'react-components'
import ObjectOverviewCard from '../../../common/object-overview-card'
import GridCard from '../../../../components/common/grid-card'
import { ListingSectionObject } from '../../../../transports/common/listing-section-transport'
import { cardEventCategories, pageTypeEventCategories } from '../../../../services/analytics-service/categories'
import { Offer } from '../../../../models/common/offers-model'
import { SuitablesModel } from '../../../../models/common/suitables-model'
import { BreadcrumbListTransport } from '../../../../models/common/breadcrumb-model'

interface Props {
    listing: ListingSectionObject
    index: number
    isGridView?: boolean
    breadcrumbModel: BreadcrumbListTransport
    offerModel: Offer
    suitablesModel: SuitablesModel
    isAboveFold?: boolean
    propagateSearchRequestId?: boolean
}

const ListingCard: FC<Props> = ({
    listing,
    index,
    isGridView = false,
    breadcrumbModel,
    offerModel,
    suitablesModel,
    isAboveFold,
    propagateSearchRequestId = false,
}) => {
    const { isMobile } = useContext(ScreenContext)

    if (isMobile || isGridView) {
        return (
            <GridCard
                index={index}
                listingObject={listing}
                displayPrice
                displayPriceInfo
                requestUrl=""
                isObjectOverview={false}
                showCtaButton
                pageName={pageTypeEventCategories.SEARCH_RESULT_LISTING_PAGE}
                sectionName={cardEventCategories.sections.LISTING_CARD}
                useCarousel
                breadcrumbModel={breadcrumbModel}
                offerModel={offerModel}
                suitablesModel={suitablesModel}
                showFeatures
                showFeatureLabel={false}
                isAboveFold={isAboveFold}
                propagateSearchRequestId={propagateSearchRequestId}
            />
        )
    }

    return (
        <ObjectOverviewCard
            index={index}
            pageName={pageTypeEventCategories.SEARCH_RESULT_LISTING_PAGE}
            sectionName={cardEventCategories.sections.LISTING_CARD}
            useCarousel
            listingObject={listing}
            showCtaButton
            showBreadcrumbsSection={false}
            breadcrumbModel={breadcrumbModel}
            offerModel={offerModel}
            suitablesModel={suitablesModel}
            isAboveFold={isAboveFold}
            propagateSearchRequestId={propagateSearchRequestId}
        />
    )
}

export default ListingCard
